import { ALL_LOCALES } from '../constants';

export const getLocaleFromLang = lang =>
  ALL_LOCALES.find(locale => locale.startsWith(lang)) ?? 'en_US';
